import { CopyIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { toast } from '@/components/Snackbar';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface CopyButtonProps {
    value: string;
}

export function CopyButton({ value }: CopyButtonProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            toast.success(t('table.copied'));
        } catch {
            toast.error(t('table.copyFailed'));
        }
    };

    return (
        <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
                <button
                    type="button"
                    onClick={copy}
                    aria-label={t('table.copy')}
                    className="shrink-0 text-grey-200 transition-colors hover:text-white-100"
                >
                    <CopyIcon className="size-4" />
                </button>
            </TooltipTrigger>
            <TooltipContent side="top">{t('table.copy')}</TooltipContent>
        </Tooltip>
    );
}
